import { CapoPlugin } from "/builds/webcontact/borsdorf/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];